import styled from "styled-components";
import tw from "twin.macro";

import { CollapseExpandSingleIcon } from "../Icons";
import { Body2 } from "../Typography";

export const StyledChildrenWrapper = styled.div`
  ${tw`tw-shrink-0`}
`;

StyledChildrenWrapper.displayName = "StyledChildrenWrapper";

export const StyledWrapper = styled.div<{ $expanded: boolean }>`
  ${tw`tw-flex tw-items-center tw-mb-4 tw-gap-4`}
  justify-content: ${({ $expanded }) =>
    $expanded ? "space-between" : "flex-start"};
`;

StyledWrapper.displayName = "StyledWrapper";

export const StyledTitle = styled(Body2)<{ $readOnly: boolean }>`
  ${tw`tw-truncate`}
  cursor: ${({ $readOnly }) => ($readOnly ? "default" : "pointer")};
`;

StyledTitle.displayName = "StyledTitle";

export const StyledDividerLine = styled.div`
  ${tw`tw-flex-1`}
  border-top: 1px solid var(--border-primary);
`;

StyledDividerLine.displayName = "StyledDividerLine";

export const StyledCollapseExpandSingleIcon = styled(CollapseExpandSingleIcon)<{
  $expanded: boolean;
}>`
  ${tw`tw-cursor-pointer tw-mr-1`}
  transform: ${({ $expanded }) =>
    $expanded ? "rotate(0deg)" : "rotate(180deg)"};
  transition: all 0.2s ease;
`;

StyledCollapseExpandSingleIcon.displayName = "StyledCollapseExpandSingleIcon";
